import React, { useState, useEffect, useMemo } from "react";
import FIREBASE from "../../../config/FIREBASE";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import actions from "../../../actions/usersListActions";
import axios from "axios";
import swal from "sweetalert";
import { API_TIMEOUT, API_TULUFALI, LIST_ADMIN_TF } from "../../../utils";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Badge,
  Label,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Spinner,
} from "reactstrap";

import Widget from "../../Widget/Widget";

import s from "../Users.module.scss";
import { useDispatch } from "react-redux";

const AdminListTable = (props) => {
  const { dispatch } = props;

  const [currentUser, setCurrentUser] = useState();
  const [rowsKu, setRowsKu] = useState([]);
  const [idHapus, setIdHapus] = useState();

  const [jumlahPenerimaBantuan, setJumlahPenerimaBantuan] = useState(0);
  const [nama, setNama] = useState("");
  const [idAdmin, setIdAdmin] = useState("");

  const [status, setStatus] = useState("");
  const [aktif, setAktif] = useState("ya");
  const [username, setUsername] = useState("");
  const [dinas, setDinas] = useState("");
  const [url, setUrl] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [cari, setCari] = useState(false);
  const [proses, setProses] = useState(false);

  const [edit, setEdit] = useState(false);
  const [tambah, setTambah] = useState(false);
  const [gambar, setGambar] = useState("");
  const [uid, setUid] = useState("");

  const [modalDelete, setModalDelete] = useState(false);
  const [modalDelete2, setModalDelete2] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatchKu = useDispatch();

  const summaryStats = useMemo(() => {
    const total = rowsKu.length;
    const byStatus = {};
    rowsKu.forEach((r) => {
      const st = String(r.status || "").trim() || "(kosong)";
      byStatus[st] = (byStatus[st] || 0) + 1;
    });
    const uniqueDinas = new Set(rowsKu.map((r) => String(r.dinas || "").trim()).filter(Boolean));
    return { total, byStatus, totalDinas: uniqueDinas.size };
  }, [rowsKu]);

  const filteredAdmins = useMemo(() => {
    const q = String(searchQuery || "").trim().toLowerCase();
    if (!q) return rowsKu;
    return rowsKu.filter(
      (r) =>
        String(r.nama || "").toLowerCase().includes(q) ||
        String(r.username || "").toLowerCase().includes(q) ||
        String(r.dinas || "").toLowerCase().includes(q) ||
        String(r.status || "").toLowerCase().includes(q)
    );
  }, [rowsKu, searchQuery]);

  const getUserEmail = (email) => {
    FIREBASE.database()
      .ref("users")
      .orderByChild("email")
      .equalTo(email)
      .once("value", (querySnapshot) => {
        setCari(false);
        const val = querySnapshot.val();
        const arrayOfNames = [];
        if (val && typeof val === "object") {
          for (const key in val) {
            if (val.hasOwnProperty(key)) {
              arrayOfNames.push(val[key]);
            }
          }
        }
        if (arrayOfNames.length > 0) {
          const user = arrayOfNames[0];
          setNama(user.nama || "");
          setUsername(user.email || "");
          setStatus("admin");
          setDinas(user.unitKerja || "");
          setUrl(user.avatar || "");
          setUid(user.uid || "");
          convertGambar(user.avatar);
        } else {
          swal("Email tidak ditemukan", "Email yang dicari tidak terdaftar di Rote Smart Service. Pastikan email sudah benar.", "info");
        }
      })
      .catch(() => {
        setCari(false);
        swal("Email tidak ditemukan", "Gagal mengambil data dari Rote Smart Service. Periksa koneksi atau pastikan email sudah terdaftar.", "info");
      });
  };

  const cariUser = (email) => {
    setCari(true);
    getUserEmail(email);
  };

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      // ambilBantuan(tahun);
      ambilListAdmin();
    }
  }, [currentUser]);

  const ambilListAdmin = () => {
    axios({
      method: "get",
      url: LIST_ADMIN_TF,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          setJumlahPenerimaBantuan(data.length);

          setRowsKu(data);

          //setFirstTable(response.data.data);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };

  const handleSimpan = () => {
    if (edit) {
      if (!nama || !username || !status || !dinas) {
        swal("Gagal", "Data yang anda masukan harus lengkap", "error");
        return;
      }
      setProses(true);
      updateAdmin();
    } else if (tambah) {
      if (!nama || !username || !status || !dinas) {
        swal("Gagal", "Data yang anda masukan harus lengkap", "error");
        return;
      }

      setProses(true);
      simpanAdmin();
    }
  };

  const handleDelete = () => {
    setProses(true);
    deleteAdmin();
  };

  const openModal3 = (cell) => {
    const id = cell;
    //  getDataPenerimabantuan(cell);
    setIdAdmin(id);

    const admin = rowsKu.filter((item) => {
      return item.id == id;
    });
    const adminKu = admin[0];

    setNama(adminKu.nama);

    setModalDelete2(true);
  };

  const closeModal2 = () => {
    setEdit(false);
    setTambah(false);
    setNama("");
    setUsername("");
    setStatus("");
    setAktif("ya");
    setDinas("");
    setUrl("");
    setSearchItem("");
    setGambar("");
    setIdAdmin("");

    setModalDelete2(false);
  };

  const deleteAdmin = async () => {
    const response = await axios.delete(
      API_TULUFALI + "postadmin/" + idAdmin,

      {
        //credentials: 'include',
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        //   Authorization: `Bearer ${accessToken}`,
        // },
      }
    );

    if (response.data.success === 1) {
      swal("Sukses", "Data Admin " + nama + " berhasil dihapus", "success");
      ambilListAdmin();
      setProses(false);
      closeModal2();
    } else {
    }
  };

  const updateAdmin = async () => {
    try {
      const response = await axios.patch(
        API_TULUFALI + "postadmin/" + idAdmin,
        { nama, username, status, dinas, aktif: aktif || "ya" },
        { timeout: API_TIMEOUT }
      );
      if (response.data.success === 1) {
        setProses(false);
        swal("Sukses", "Data Admin berhasil diubah", "success");
        closeModal();
        ambilListAdmin();
      } else {
        setProses(false);
        swal("Gagal", response.data?.message || "Gagal mengubah data", "error");
      }
    } catch (err) {
      setProses(false);
      swal("Gagal", err.response?.data?.message || err.message || "Gagal mengubah data", "error");
    }
  };

  const simpanAdmin = async () => {
    const formData = new FormData();
    formData.append("photo", gambar);

    formData.append("uid", uid);
    formData.append("dinas", dinas);
    formData.append("username", username);
    formData.append("status", status);

    formData.append("nama", nama);

    const response = await axios.post(
      API_TULUFALI + "postadmin",
      formData,
      {
        //credentials: 'include',
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        //   Authorization: `Bearer ${accessToken}`,
        // },
      }
    );

    if (response.data.success === 1) {
      setProses(false);
      swal("Sukses", "Data Admin " + nama + " berhasil ditambahkan", "success");

      closeModal();
      ambilListAdmin();
    }
  };

  const convertGambar = (avatar) => {
    // Data gambar dalam format data URI
    if (avatar) {
      const imageDataURI = avatar; // Sisipkan data gambar lengkap di sini

      // Memisahkan data URI menjadi tipe dan base64 encoded data
      const [dataType, base64Data] = imageDataURI.split(",");

      // Mengubah base64 encoded data menjadi bentuk binary
      const binaryData = atob(base64Data);

      // Mendapatkan panjang data binary
      const len = binaryData.length;

      // Membuat array untuk menyimpan data binary dalam bentuk Uint8Array
      const uint8Array = new Uint8Array(len);

      // Mengisi array dengan data binary
      for (let i = 0; i < len; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      // Membuat file baru dari Uint8Array dan menambahkan tipe datanya
      const file = new File([uint8Array], "gambar.jpg", { type: dataType });

      setGambar(file);
    } else {
      setGambar("");
    }
  };

  const openModal = (cell) => {
    const id = cell;
    //  getDataPenerimabantuan(cell);
    setIdAdmin(id);

    const admin = rowsKu.filter((item) => {
      return item.id == id;
    });
    const adminKu = admin[0];

    setNama(adminKu.nama);
    setUsername(adminKu.username);
    setStatus(adminKu.status);
    setDinas(adminKu.dinas);
    setUrl(adminKu.profile);
    setAktif(String(adminKu.aktif || "").trim().toLowerCase() === "tidak" ? "tidak" : "ya");

    setModalDelete(true);
  };

  const openModal2 = () => {
    setTambah(true);

    setModalDelete(true);
  };

  const closeModal = () => {
    setEdit(false);
    setTambah(false);
    setNama("");
    setUsername("");
    setStatus("");
    setAktif("ya");
    setDinas("");
    setUrl("");
    setSearchItem("");
    setGambar("");
    setCari(false);

    setModalDelete(false);
  };

  useEffect(() => {
    dispatch(actions.doFetch({}));
  }, []);

  return (
    <div>
      <Widget className="widget-p-md">
        <Row className="mb-3">
          <Col xs={12}>
            <div className={`d-flex flex-wrap align-items-center ${s.summaryChipsWrap}`}>
              <span className={s.summaryChip} id="chip-total-admin">
                <span className={s.summaryChipLabel}>Total Admin</span>
                <Badge color="primary" pill className={s.summaryChipValue}>
                  {summaryStats.total}
                </Badge>
              </span>
              {Object.entries(summaryStats.byStatus).map(([st, cnt]) => (
                <span key={st} className={s.summaryChip} id={`chip-status-${st.replace(/\s/g, "-")}`}>
                  <span className={s.summaryChipLabel}>{st}</span>
                  <Badge color="info" pill className={s.summaryChipValue}>
                    {cnt}
                  </Badge>
                </span>
              ))}
              <span className={s.summaryChip} id="chip-total-dinas">
                <span className={s.summaryChipLabel}>Total Dinas</span>
                <Badge color="success" pill className={s.summaryChipValue}>
                  {summaryStats.totalDinas}
                </Badge>
              </span>
            </div>
          </Col>
        </Row>
        <Row className="align-items-end mb-3">
          <Col xs={12} sm={6} md={4} className="mb-2">
            <Input
              placeholder="Cari berdasarkan nama dan dinas..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="form-control-sm"
            />
          </Col>
          <Col xs={12} sm={6} md={8} className="mb-2 text-right">
            <Button color="success" size="sm" onClick={() => openModal2()}>
              <i className="fa fa-plus mr-2" />
              Tambah Admin
            </Button>
          </Col>
        </Row>
        <Row>
          {filteredAdmins.map((admin) => {
            const hasValidPhoto = admin.profile && String(admin.profile).trim() && admin.profile !== "-";
            const aktifVal = String(admin.aktif || "").trim().toLowerCase() || "ya";
            const isSuperAdmin = String(admin.status || "").toLowerCase() === "super admin";
            return (
              <Col key={admin.id} xs={12} sm={6} lg={4} className="mb-3">
                <Card className={`${s.adminCard} h-100 ${aktifVal === "tidak" ? s.adminCardInactive : ""}`}>
                  <div className={s.adminCardHeader}>
                    <div className={s.adminCardAvatar}>
                      {hasValidPhoto ? (
                        <img
                          src={admin.profile}
                          alt={admin.nama}
                          onError={(e) => {
                            e.target.style.display = "none";
                            const icon = e.target.nextElementSibling;
                            if (icon) icon.classList.remove("d-none");
                          }}
                        />
                      ) : null}
                      <i className={`fa fa-user ${hasValidPhoto ? "d-none" : ""}`} aria-hidden="true" />
                    </div>
                    <div className="flex-grow-1 min-w-0">
                      <h6 className={`${s.adminCardName} mb-1`}>{admin.nama || "-"}</h6>
                      <div className={s.adminCardBadges}>
                        <Badge color={isSuperAdmin ? "warning" : "secondary"} className="mr-1">
                          {admin.status || "-"}
                        </Badge>
                        <Badge color={aktifVal === "ya" ? "success" : "light"} className="text-dark">
                          {aktifVal}
                        </Badge>
                      </div>
                    </div>
                  </div>
                  <CardBody className={s.adminCardBody}>
                    <div className={s.adminCardMeta}>
                      <div>{admin.username || "-"}</div>
                      <div className="mt-1">{admin.dinas || "-"}</div>
                    </div>
                    <div className={`d-flex mt-3 ${s.adminCardActions}`} style={{ gap: 8 }}>
                      <Button
                        color="secondary"
                        size="sm"
                        outline
                        className="flex-grow-1"
                        onClick={() => {
                          setEdit(true);
                          openModal(admin.id);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        outline
                        className="flex-grow-1"
                        onClick={() => openModal3(admin.id)}
                      >
                        Hapus
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
        {filteredAdmins.length === 0 && (
          <div className="text-center py-4 text-muted small">
            {rowsKu.length === 0 ? "Belum ada data admin" : "Tidak ada hasil pencarian"}
          </div>
        )}
      </Widget>
      <Modal size="md" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>Admin Tulu Fali</ModalHeader>
        <ModalBody>
          <FormGroup>
            <CardBody>
              {tambah && (
                <FormGroup>
                  <InputGroup>
                    <Input
                      type="text"
                      id="search-input1"
                      value={searchItem}
                      onChange={(e) => setSearchItem(e.target.value)}
                    />
                    <InputGroupAddon addonType="append">
                      {cari ? (
                        <Button color="default" disabled>
                          <Spinner size="sm" color="light" /> Loading
                        </Button>
                      ) : (
                        <Button
                          color="default"
                          onClick={() => cariUser(searchItem)}
                        >
                          Search
                        </Button>
                      )}
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              )}
              {url && (
                <Row style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={url ? url : ""}
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 50,

                      marginBottom: 10,
                      border: "2px solid blue",
                    }}
                  />
                </Row>
              )}
              {nama && (
                <Form onSubmit={(e) => ""}>
                  <FormGroup row>
                    <Label md={3} for="normal-field" className="text-md-right">
                      Nama
                    </Label>
                    <Col md={9}>
                      <Input
                        type="text"
                        id="default-textarea"
                        placeholder="nama"
                        value={nama}
                        onChange={(e) => setNama(e.target.value)}
                        required
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label md={3} for="normal-field" className="text-md-right">
                      Username
                    </Label>
                    <Col md={9}>
                      <Input
                        type="text"
                        id="default-textarea"
                        placeholder="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label md={3} for="normal-field" className="text-md-right">
                      Peran
                    </Label>
                    <Col md={9}>
                      <Input
                        type="select"
                        id="normal-field"
                        placeholder=""
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        required
                      >
                        <option value={""}>- Pilih peran -</option>
                        <option value={"admin"}>admin</option>
                        <option value={"super admin"}>super admin</option>
                      </Input>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label md={3} for="normal-field" className="text-md-right">
                      Dinas
                    </Label>
                    <Col md={9}>
                      <Input
                        type="text"
                        id="normal-field"
                        placeholder=""
                        value={dinas}
                        onChange={(e) => setDinas(e.target.value)}
                        required
                      />
                    </Col>
                  </FormGroup>
                  {edit && (
                    <FormGroup row>
                      <Label md={3} for="aktif-field" className="text-md-right">
                        Aktif
                      </Label>
                      <Col md={9}>
                        <Input
                          type="select"
                          id="aktif-field"
                          value={aktif}
                          onChange={(e) => setAktif(e.target.value)}
                        >
                          <option value="ya">Ya</option>
                          <option value="tidak">Tidak</option>
                        </Input>
                      </Col>
                    </FormGroup>
                  )}
                </Form>
              )}
            </CardBody>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Cancel
          </Button>
          {proses ? (
            <Button color="default" disabled>
              <Spinner size="sm" color="light" /> Kirim
            </Button>
          ) : (
            <Button color="primary" onClick={() => handleSimpan()}>
              {tambah ? "Tambah" : "Simpan"}
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalDelete2} toggle={() => closeModal2()}>
        <ModalHeader toggle={() => closeModal2()}>Hapus Admin</ModalHeader>
        <ModalBody>
          <FormGroup>
            <CardBody>
              {"Apakah anda yakin ingin menghapus admin atas nama "}
              <code> {nama}</code>
              {" ?"}
            </CardBody>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={() => closeModal2()}>
            Cancel
          </Button>
          {proses ? (
            <Button
              size={modalDelete2 ? "sm" : "md"}
              color={modalDelete2 ? "default" : "danger"}
              disabled
            >
              <Spinner size="sm" color="light" />{" "}
              {modalDelete2 ? "proses" : "Kirim"}
            </Button>
          ) : (
            <Button size="sm" color="danger" onClick={() => handleDelete()}>
              {"Hapus"}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(store) {
  return {
    loading: store.users.list.loading,
    rows: store.users.list.rows,
    modalOpen: store.users.list.modalOpen,
    idToDelete: store.users.list.idToDelete,
  };
}

export default connect(mapStateToProps)(AdminListTable);
